import React from 'react'
import { twMerge } from 'tailwind-merge'
import { useTranslation } from 'react-i18next'
import { Link, Outlet, useNavigate } from 'react-router-dom'
import { ABOUT_PATH, ADMIN_PATH, LOGIN_PATH, PROFILE_PATH } from '../App'
import LanguageSwitcher from '../components/language-switcher'
import SocialMediaLink from '../components/social-media-link'
import { useAuth } from '../contexts/auth-context'

export default function PublicLayout() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    return (
        <div className="flex-center justify-start min-h-screen w-full">
            <nav className={twMerge(
                'fixed top-0 left-0 z-[999] flex flex-row justify-between md:justify-around items-center px-4 gap-4 w-full',
                'bg-gray-400 bg-clip-padding backdrop-filter backdrop-blur-lg bg-opacity-10 border-b-2 border-gray-100'
            )}>
                <div className='overflow-hidden flex-1 flex-center hidden md:flex'>
                    <a href="/#home" className='nav-item text-center uppercase font-bold'>
                        {t('landing.home')}
                    </a>
                </div>

                <div className='overflow-hidden flex-1 flex-center hidden md:flex'>
                    <a href="/#rankings" className='nav-item text-center uppercase font-bold'>
                        {t('landing.rankings')}
                    </a>
                </div>

                <div className='overflow-hidden md:flex-1 flex-center'>
                    <a href='/#home' className='nav-item flex-center text-center'>
                        <img className='h-14 py-2 object-contain object-center' src="/assets/img/logo-mfl.png" alt="logo" />
                    </a>
                </div>
                <div className="flex-1 md:hidden" />

                <div className='overflow-hidden flex-1 flex-center hidden md:flex'>
                    <a href="/#events" className='nav-item text-center uppercase font-bold'>
                        {t('landing.events')}
                    </a>
                </div>

                <div className='md:flex-1 flex-center overflow-hidden'>
                    {
                        !currentUser ?
                            <button className="nav-item text-center uppercase font-bold underline" onClick={() => navigate(LOGIN_PATH)}>
                                {t('landing.login')}
                            </button>
                            : (
                                currentUser.role?.toUpperCase() === "ADMIN" ?
                                    <button className="nav-item text-center uppercase font-bold underline" onClick={() => navigate(ADMIN_PATH)}>
                                        {t('landing.dashboard')}
                                    </button>
                                    :
                                    <button className="nav-item text-center uppercase font-bold underline" onClick={() => navigate(PROFILE_PATH)}>
                                        {t('landing.profile')}
                                    </button>
                            )
                    }
                </div>
            </nav>
            <main id="home" className='w-full pt-16 relative h-full overflow-y-auto pb-10'>
                <Outlet />
            </main>
            <footer className='fixed bottom-0 left-0 w-full bg-white text-black z-[999]'>
                <div className='w-full px-4 py-2 flex flex-row justify-between items-center'>
                    <div className='overflow-hidden'>
                        <LanguageSwitcher className='pr-4' />
                    </div>
                    <div className='overflow-hidden'>
                        <Link to={ABOUT_PATH} >
                            <p className='about-us uppercase font-bold '>{t('landing.aboutUs')}</p>
                        </Link>
                    </div>
                    <div className="flex-1" />
                    <div className="flex flex-row gap-6">
                        <div className="overflow-hidden">
                            <SocialMediaLink className={"social-media-link"} iconPath={"/assets/icon/facebook.svg"} label="Facebook" href={"https://www.facebook.com/MalaysiaFightLeague/"} />
                        </div>
                        <div className="overflow-hidden">
                            <SocialMediaLink className={"social-media-link"} iconPath={"/assets/icon/instagram.svg"} label="Instagram" href={"https://www.instagram.com/malaysiafightleague/"} />
                        </div>
                        <div className="overflow-hidden">
                            <SocialMediaLink className={"social-media-link"} iconPath={"/assets/icon/tiktok.svg"} label="TikTok" href={"https://www.tiktok.com/@malaysiafightleague?_t=8avi41ssbah&_r=1"} />
                        </div>
                        <div className="overflow-hidden">
                            <SocialMediaLink className={"social-media-link"} iconPath={"/assets/icon/youtube.svg"} label="YouTube" href={"https://youtube.com/@malaysiafightleague"} />
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}
